import { Axios } from '@utils/api/axios-instance';
import { POST_URL } from '@utils/api/endpoints';
import { TokenExtension } from '@utils/extensions/token.extension';
import { useMutation, UseMutationResult } from 'react-query';

interface RequestUploadUrlPayload {
  sessionId: string;
}

interface RequestUploadUrlResponse {
  result: {
    upload_url: string;
    expires_at: string;
    session_id: string;
    max_file_size: number;
  };
}

const requestUploadUrl = async (
  payload: RequestUploadUrlPayload
): Promise<RequestUploadUrlResponse> => {
  const authToken = TokenExtension.get();

  const response = await Axios.post<RequestUploadUrlResponse>(
    POST_URL(payload.sessionId).requestUploadUrl,
    {},
    {
      headers: {
        Authorization: `Bearer ${authToken.string}`
      }
    }
  );

  return response.data;
};

export const useRequestUploadUrl = (): UseMutationResult<
  RequestUploadUrlResponse,
  Error,
  RequestUploadUrlPayload
> => {
  return useMutation(requestUploadUrl);
};
